import * as React from "react";

import LanguageProvider from "providers/languageProvider";

import IconImageNotFoundActive from "../../assets/img/image-not-found-active.svg";
import IconImageNotFoundInactive from "../../assets/img/image-not-found-inactive.svg";

import IIncidentTypeItemProps from "./interfaces/IIncidentTypeItemProps";

export default class IncidentTypeItem extends React.Component<IIncidentTypeItemProps> {
  public constructor(props: IIncidentTypeItemProps) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.imageSrc = this.imageSrc.bind(this);
  }

  public imageSrc(): string {
    if (this.props.active) {
      return this.props.incidentType.icons.activeImageExists
        ? this.props.incidentType.icons.active
        : IconImageNotFoundActive;
    }
    return this.props.incidentType.icons.inactiveImageExists
      ? this.props.incidentType.icons.inActive
      : IconImageNotFoundInactive;
  }

  public render(): JSX.Element {
    const name = this.props.name !== "" ? this.props.name : LanguageProvider.t("images.namenotfound");

    return (
      <button
        onClick={this.onClick}
        type="button"
        title={name}
        className={`btn btn--image-label mb-3 ${this.props.active ? "active" : "inactive"}`}
      >
        <img src={this.imageSrc()} alt="" />
        <div>{name}</div>
      </button>
    );
  }

  private onClick(): void {
    if (this.props.selectingDisabled) {
      return;
    }

    this.props.onItemClick(this.props.incidentType);
  }
}
